<template>
  <div class="flex">
    <div
      @click="emit('update:modelValue', option.key)"
      v-for="option in options"
      :key="option.key"
      class="px-4 py-2.5 text-gray-800 cursor-pointer hover:bg-gray-100 border-gray-300 font-semibold text-sm basis-0 flex-grow flex flex-row justify-center items-center"
      :class="[
        {
          'bg-sky-50 text-sky-800 hover:bg-sky-100': option.key === modelValue,
          '!text-gray-300 cursor-not-allowed pointer-events-none': disabled,
        },
        standalone
          ? 'first:rounded-l-lg last:rounded-r-lg border border-l-0 first:border-l'
          : 'first:rounded-tl-lg last:rounded-tr-lg border-0 border-b border-r last:border-r-0',
      ]"
    >
      {{ option.label }}
      <div
        v-if="showCount"
        class="grid place-items-center aspect-square px-2 ml-2 rounded-full bg-gray-100 text-gray-700 text-xs"
      >
        {{ option.count }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  options: Array,
  modelValue: String,
  disabled: Boolean,
  standalone: {
    type: Boolean,
    default: true,
  },
  showCount: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue"]);
</script>
